import React, { Component } from 'react';
import { connect } from 'react-redux';
import LoginView from './login-view';
import { login } from './login-actions';
import Utils from '../../library/utils';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      rememberMe: false
    }
  }

  componentDidMount() {
    if (this.props.auth.rememberMe) {
     this.setState({email: this.props.auth.rememberedEmail, rememberMe: true})
    }
  }

  toggleRememberMe = () => this.setState({rememberMe: !this.state.rememberMe});

  onChangeEmail = (e) => {
    this.setState({email: e.target.value})
  };

  onChangePassword = (e) => {
    this.setState({password: e.target.value})
  };

  login = () => {
    this.props.login(this.state.email, this.state.password, this.state.rememberMe);
  };

  handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.login();
    }
  };

  render() {
    return (
      <LoginView
        {...this.props}
        login={this.login}
        loading={this.props.auth.isFetching}
        email={this.state.email}
        password={this.state.password}
        onChangeEmail={this.onChangeEmail}
        onChangePassword={this.onChangePassword}
        disabled={(!Utils.isValidEmail(this.state.email) || Utils.isBlank(this.state.password) && this.state.rememberMe === false)}
        toggleRememberMe={this.toggleRememberMe}
        rememberMe={this.state.rememberMe}
        handleKeyDown={this.handleKeyDown}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth
});

const mapDispatchToProps = {
  login: login
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);




// WEBPACK FOOTER //
// ./src/components/login/login.js